import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useBodyId = () => {
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname === "/marketingResources" ||
      location.pathname === "/manageAccount" ||
      location.pathname === "/buyback" ||
      location.pathname === "/manageFreeLink" ||
      location.pathname === "/roiCalculator" ||
      location.pathname === "/serviceData" ||
      location.pathname === "/referFriend" ||
      location.pathname === "/faq"
    ) {
      const routeName = "manageAccount";
      document.body.id = routeName;
    }
  }, [location]);
};

export default useBodyId;
